import { render, staticRenderFns } from "./ServiceCentersEl.vue?vue&type=template&id=84e54678&scoped=true"
import script from "./ServiceCentersEl.vue?vue&type=script&lang=js"
export * from "./ServiceCentersEl.vue?vue&type=script&lang=js"
import style0 from "./ServiceCentersEl.vue?vue&type=style&index=0&id=84e54678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e54678",
  null
  
)

export default component.exports